module.exports = __webpack_public_path__ + "static/media/studentlogin.e0b6f1f1.png";